module.exports = __webpack_public_path__ + "static/media/archer_destination_default.740fefe7.svg";